import { marked } from "marked";

const renderPandocImages = (md = "") =>
  md.replace(/!\[([^\]]*)\]\(([^)]+)\)\{([^}]*)\}/g, (_, alt, src, attrs) => {
    let styles = "";
    attrs.replace(/(\w+)\s*=\s*"([^"]+)"/g, (_, k, v) => {
      styles += `${k}:${v};`;
    });
    return `<img src="${src}" alt="${alt}" style="${styles}" />`;
  });

const renderHTML = (md) => ({
  __html: marked.parse(renderPandocImages(md || "")),
});

const normalizeToString = (val) => {
  if (Array.isArray(val)) return val.join("\n\n");
  return val || "";
};

export default function FullViewOverlay({
  showSource,
  showTarget,
  sourceContents,
  targetContents,
  onClose,
  rtlSource,
  rtlTarget
}) {
  if (!showSource && !showTarget) return null;

  const sourceHtml = marked.parse(
    renderPandocImages(normalizeToString(sourceContents))
  );
  
  const targetHtml = marked.parse(
    renderPandocImages(normalizeToString(targetContents))
  );

  const showBoth = showSource && showTarget;

  return (
    <div className="fixed inset-0 z-50 mt-[100px] bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">

      {/* close on backdrop */}
      <div
        className="absolute inset-0"
        onClick={onClose}
      />

      {/* content BELOW navbar */}
      <div className="relative h-[calc(100vh-4rem)] bg-white">
        {/* close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-4xl text-gray-700 z-[9999]"
        >
          X
        </button>

        {/* layout */}
        <div
          className={`h-full grid ${
            showBoth
              ? "grid-cols-1 md:grid-cols-2"
              : "grid-cols-1"
          }`}
        >
          {showSource && (
            <div className={`overflow-y-auto p-6 ${rtlSource ? "rtl-textarea" : ""} border-r dark:border-gray-700`}>
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={renderHTML(sourceHtml) }
              />
            </div>
          )}

          {showTarget && (
            <div className={`overflow-y-auto p-6 ${rtlTarget ? "rtl-textarea" : ""}`}>
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={ renderHTML(targetHtml)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
